import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import styles from 'assets/jss/material-dashboard-pro-react/components/buttonStyle';

// @ts-ignore
const useStyles = makeStyles(styles);

type IRegularButtonSize = 'sm' | 'lg';
interface IRegularButton extends Omit<React.HTMLProps<HTMLButtonElement>, 'size' | 'onClick'> {
	color: types.theme.buttonColor;
	size?: IRegularButtonSize;
	round?: boolean;
	fullWidth?: boolean;
	disabled?: boolean;
	block?: boolean;
	onClick?: Function;
	className?: string;
	muiClasses?: object;
	children: string | React.ReactElement | React.ReactElement[];
	justIcon?: boolean;
	withIcon?: boolean;
	id?: string;
	hidden?: boolean;
	noMargin?: boolean;
}

const RegularButton = React.forwardRef(
	(
		{
			color,
			children,
			fullWidth,
			disabled,
			size,
			justIcon,
			round,
			className,
			block,
			muiClasses,
			withIcon,
			id,
			hidden,
			noMargin,
			...rest
		}: IRegularButton,
		ref
	) => {
		const classes = useStyles();

		const btnClasses = classNames({
			[classes.button]: true,
			[classes[size]]: size,
			[classes[color]]: color,
			[classes.round]: round,
			[classes.fullWidth]: fullWidth,
			[classes.disabled]: disabled,
			[classes.hidden]: hidden,
			[classes.block]: block,
			[classes.justIcon]: justIcon,
			[classes.withIcon]: withIcon,
			[classes.noMargin]: noMargin,
			[className ? className : '']: className,
		});
		return (
			// @ts-ignore
			<Button {...rest} disabled={disabled} ref={ref} classes={muiClasses} className={btnClasses} id={id}>
				{children}
			</Button>
		);
	}
);

export default RegularButton;
